import coinManagementComponent from "./coin_management.component";

let coinManagementModule = angular
  .module("coinManagement", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/coinManagement");

    $stateProvider.state("coinManagement", {
      url: "/v2/index.html#/coin-management",
      component: "coinManagement",
      data: {
        requireLogin: true,
        requireACL: "coin_management.all",
      },
    });
  })
  .component("coinManagement", coinManagementComponent).name;

export default coinManagementModule;



// WEBPACK FOOTER //
// ./client/app/components/coin_management/index.js